// extracted by mini-css-extract-plugin
export default {"error":"AppConfig_error__60T1u"};